module.exports = __webpack_public_path__ + "static/media/intro-footer-bg.3ccb1293.png";